import type { CaseStatus } from '../../shared/case-schema.js';

const LABELS: Record<CaseStatus, string> = {
  SUBMITTED: 'Submitted',
  REVIEWING: 'Under review',
  POSSIBLE_MATCH: 'Possible match',
  RETURN_DETAILS_PROVIDED: 'Return details provided',
  READY_FOR_PICKUP: 'Ready for pickup',
  SHIPPED: 'Shipped',
  RETURNED: 'Returned',
  CLOSED_NOT_FOUND: 'Closed, not found',
};

export function StatusBadge({ status }: { status: CaseStatus }) {
  return <span className={`status-badge status-${status.toLowerCase()}`}>{LABELS[status]}</span>;
}

export function statusLabel(status: CaseStatus): string {
  return LABELS[status];
}
